module.exports = __webpack_public_path__ + "static/media/menu-invites-selected.22285242.svg";